import { useLoaderData } from "react-router";

import { processRequest } from "@api/config";
import { newsAPI } from "@api/news";

import { TSessionData } from "@storage/session/types";

import { useAuthQuery } from "@lib/queryClient";

import { API_PREFIXES, QUERY_KEYS } from "@configs/api";

export const useNewsListQuery = () => {
	const { currentAccount } = useLoaderData<TSessionData>();

	return useAuthQuery({
		queryKey: [QUERY_KEYS.NEWS_DATA],
		queryFn: async () => {
			const data = await processRequest({
				prefix: API_PREFIXES.GET_NEWS_LIST,
				request: () => newsAPI.getNewsListAsync({ modelNickName: currentAccount.bss_username || "" }),
			});

			return data;
		},
	});
};
